import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatPanelService } from '../../services/chat-panel.service';

@Component({
  selector: 'app-chat-launcher',
  templateUrl: './chat-launcher.component.html',
  styleUrls: ['./chat-launcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChatLauncherComponent {
  isOpen$: Observable<boolean>;

  constructor(private chatPanelService: ChatPanelService) {
    this.isOpen$ = this.chatPanelService.isOpen$;
  }

  toggleChat() {
    this.chatPanelService.toggleOpen();
  }
}
